<template>
  <v-row>
    <v-col cols="6">
      <v-combobox
          v-model="select"
          :loading="loading"
          :items="items"
          :search-input.sync="search"
          class="mx-4"
          :filter="filterAutocomplete"
          hide-no-data
          hide-details
          :label="Translator('admin.notice_collection.facets.search')"
          item-text="titles.native_title"
          @change="change"
          :return-object="true"
          :menu-props="{closeOnContentClick:true}"
      ></v-combobox>
    </v-col>
    <v-col cols="1">
      <v-btn color="primary" @click="submitSearch">
        <v-icon>mdi-magnify</v-icon>
      </v-btn>
    </v-col>
    <v-col cols="3" v-if="showBtnSearchHistory">
      <v-btn olor="primary" @click="showSearchHistory = !showSearchHistory">
        <v-icon>mdi-history</v-icon>
        Historique de recherche
      </v-btn>
    </v-col>
    <v-col cols="2">
      <v-btn href="/fr/cart" target="_blank" color="primary">
        <v-icon>mdi-cart</v-icon>
        Panier ({{ cartLength }})
      </v-btn>
    </v-col>
    <v-col cols="12" v-if="showSearchHistory">
      <h2>Historique de recherche</h2>
      <div>
      <v-chip
          class="ma-2 pa-2"
          color="primary"
          label
          v-for="searchHistory in searchHistories"
          v-bind:key="searchHistory.url"
          :href="searchHistory.url"
      >
        {{ searchHistory.query }} <span v-if="searchHistory.facets.length > 0">({{ showFacets(searchHistory.facets) }})</span>
      </v-chip>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import axios from 'axios'

export default {
  props: ['value'],
  data () {
    return {
      loading: false,
      items: [],
      search: null,
      select: null,
      showBtnSearchHistory: false,
      showSearchHistory: false
    }
  },
  mounted () {
    const config = this.$store.state.config
    if (config['render']['show_search_history'] !== null)
      this.showBtnSearchHistory = config['render']['show_search_history']
  },
  computed: {
    cartLength () {
      return this.$store.state.cart.length
    },
    searchHistories(){
      return this.$store.state.searchHistory
    }
  },
  watch: {
    search (val) {
      if (!val) {
        return
      }

      this.fetchEntriesDebounced(val)
    },
    value (val) {
      this.select = val
    }
  },
  methods: {
    filterAutocomplete() {
      return true;
    },
    change () {
      this.items = []
      if (typeof this.select === 'string') {
        this.$emit('submitautocomplete', this.select)
      } else {
        window.location.href = this.select.url
      }
    },
    submitSearch () {
      this.$emit('submitautocomplete', this.select)
    },
    showFacets(facets){
      return facets.join(",")
    },
    fetchEntriesDebounced(val) {
      // cancel pending call
      clearTimeout(this._timerId)

      // delay new call 500ms
      this._timerId = setTimeout(() => {
        this.getNotices(val)
      }, 500)
    },
    getNotices (val) {
      this.loading = true
      axios
          .get('/api/v2/notices/search-autocomplete', {
            params: {
              query: val,
              page: 1,
              items_per_page: 5,
              onlineFilter: true
            }
          })
          .then(response => {
            this.items = response.data['hydra:member']
          })
          .catch(error => {
            console.error(error)
            this.errored = true
          })
          .finally(() => this.loading = false)
    },
    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    }
  },
}
</script>

<style scoped>

</style>
